import React from 'react';
import PropTypes from 'prop-types';
import styles from './DesktopMenuItem.scss';
import notifyAnalytics from '../notify-analytics';
import formatTestId from '../../../utils/test-id/format-testid';

const DesktopMenuItem = ({
  label,
  url,
  children,
  active,
  onSelect,
  onClose,
}) => {
  const handleOnClick = e => {
    if (!active && children) {
      e.preventDefault();
      onSelect();
    } else {
      notifyAnalytics(label);
    }
  };

  return (
    <li
      className={styles.desktopMenuItem}
      onMouseEnter={onSelect}
      onMouseLeave={onClose}
      data-testid={formatTestId(label, 'nav-')}
    >
      <a
        className={styles.desktopMenuItemLink}
        href={url}
        onClick={e => handleOnClick(e)}
      >
        {label}
      </a>
      {active && children}
    </li>
  );
};

DesktopMenuItem.defaultProps = {
  children: undefined,
};

DesktopMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default DesktopMenuItem;
